export const growthKeys = {
  all: ['growth'] as const,
  dashboard: () => [...growthKeys.all, 'dashboard'] as const,
  approvals: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'approvals', 'list', filters] as const,
    summary: () => [...growthKeys.all, 'approvals', 'summary'] as const,
  },
  autopilotLog: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'autopilot-log', 'list', filters] as const,
    timeline: (days: number) => [...growthKeys.all, 'autopilot-log', 'timeline', days] as const,
  },
  leads: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'leads', 'list', filters] as const,
    summary: (period?: string) => [...growthKeys.all, 'leads', 'summary', period] as const,
    detail: (id: string) => [...growthKeys.all, 'leads', 'detail', id] as const,
  },
  campaigns: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'campaigns', 'list', filters] as const,
    summary: (period?: string) => [...growthKeys.all, 'campaigns', 'summary', period] as const,
    report: (id: string, period?: string) =>
      [...growthKeys.all, 'campaigns', 'report', id, period] as const,
    draft: (suggestionId: string) =>
      [...growthKeys.all, 'campaigns', 'draft', suggestionId] as const,
  },
  suggestedCampaigns: () => [...growthKeys.all, 'suggested-campaigns'] as const,
  calls: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'calls', 'list', filters] as const,
    summary: (period?: string) => [...growthKeys.all, 'calls', 'summary', period] as const,
    trackingNumbers: () => [...growthKeys.all, 'calls', 'tracking-numbers'] as const,
    detail: (id: string) => [...growthKeys.all, 'calls', 'detail', id] as const,
  },
  market: () => [...growthKeys.all, 'market-intelligence'] as const,
  competitors: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'competitors', 'list', filters] as const,
    dossier: (id: string) => [...growthKeys.all, 'competitors', 'dossier', id] as const,
    crawl: (id: string) => [...growthKeys.all, 'competitors', 'crawl', id] as const,
  },
  localMarket: (radius?: number) => [...growthKeys.all, 'local-market', radius] as const,
  localMarketDetail: (id: string) => [...growthKeys.all, 'local-market', 'detail', id] as const,
  mapPack: () => [...growthKeys.all, 'map-pack'] as const,
  keywords: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'keywords', 'list', filters] as const,
    brief: (id: string) => [...growthKeys.all, 'keywords', 'brief', id] as const,
  },
  articles: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'articles', 'list', filters] as const,
    detail: (id: string) => [...growthKeys.all, 'articles', 'detail', id] as const,
    summary: () => [...growthKeys.all, 'articles', 'summary'] as const,
    calendar: (weeks?: number) => [...growthKeys.all, 'articles', 'calendar', weeks] as const,
  },
  landingPages: {
    list: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'landing-pages', 'list', filters] as const,
    detail: (id: string) => [...growthKeys.all, 'landing-pages', 'detail', id] as const,
  },
  websiteHealth: () => [...growthKeys.all, 'website-health'] as const,
  schema: () => [...growthKeys.all, 'schema'] as const,
  citations: () => [...growthKeys.all, 'citations'] as const,
  gbp: {
    overview: () => [...growthKeys.all, 'gbp'] as const,
    reviews: (page: number) => [...growthKeys.all, 'gbp', 'reviews', page] as const,
    posts: (page: number) => [...growthKeys.all, 'gbp', 'posts', page] as const,
    qa: (page: number) => [...growthKeys.all, 'gbp', 'qa', page] as const,
    photos: (filters: Record<string, unknown>) =>
      [...growthKeys.all, 'gbp', 'photos', filters] as const,
    uploadSession: (id: string) => [...growthKeys.all, 'gbp', 'upload-session', id] as const,
  },
  monthlyReport: (month?: string) => [...growthKeys.all, 'monthly-report', month] as const,
  monthlyReportMonths: () => [...growthKeys.all, 'monthly-report', 'months'] as const,
  settings: () => [...growthKeys.all, 'settings'] as const,
  setupChecklist: () => [...growthKeys.all, 'setup-checklist'] as const,
};
